import type { MdySubscription } from "@hz/common/monday/subscription.types";
import { AccountDocument, Item } from "../schemas/types";

export function includeIfDefined<T, K extends keyof T>(
  key: K,
  value: T[K] | undefined | null,
): Partial<Pick<T, K>> {
  return value !== undefined && value !== null ? ({ [key]: value } as Partial<Pick<T, K>>) : {};
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function convertEntityMappingToObject(entityMapping: Map<string, any>) {
  const obj: Record<string, { id: string; name: string }> = {}; // Explicitly type the output object

  entityMapping.forEach((value, key) => {
    if (value) {
      const { id, name } = value;
      obj[key] = { id, name }; // Safely assign to obj
    }
  });

  return obj;
}

export function capitalizeKeys<T extends object>(obj: T) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  const result = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
      // @ts-ignore: TODO
      result[capitalizedKey] = obj[key];
    }
  }
  return result;
}

export const getHasPaidSubscription = (subscription: MdySubscription | null): boolean => {
  if (!subscription) {
    return false;
  }

  const { days_left, renewal_date, is_trial } = subscription;

  if (is_trial) {
    return false;
  }

  // Checks if `days_left` is greater than 0
  if (days_left > 0) {
    return true;
  }

  // Checks if `renewal_date` is in the future
  const now = new Date();
  const renewalDate = new Date(renewal_date);

  if (renewalDate > now) {
    return true;
  }

  // Paid Subscription not active
  return false;
};

type GetItem = {
  account: AccountDocument;
  boardId: number;
  mondayItemId: number;
}

export const getItem = ({account, boardId, mondayItemId}: GetItem): Item => {
  const board = account.boards.find((b) => b.boardId === boardId);
  const gmcEntity = board?.entities.find((e) => e.entityType === "GMC");
  const item = gmcEntity?.items.find((i) => i.mondayItemId === mondayItemId);

  if (!item) throw new Error("Item not found");

  return item;
}
